import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    classes: "modal-wrapper",
    showClose: false,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", { class: "modal-wrapper" }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-title bold" }, "Check your inbox", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("div", { class: "text-container" }, [
            _createElementVNode("div", { class: "text" }, "Your instant quote will arrive in your inbox shortly. Hang tight!")
          ])
        ], -1)),
        _createElementVNode("button", {
          class: "button primary",
          type: "submit",
          onClick: $setup.onClose
        }, "Return to masterplan")
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}